import axios, { AxiosRequestConfig } from 'axios'
import * as R from 'ramda'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConfig from '$config/frontend'
import { getAuthToken } from '$logic/auth'

const instance = axios.create({
  baseURL: hostConfig.WAPP_ACTIVITY_HOST,
})

export function postRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  return instance.post<T>(
    url,
    data,
    R.assocPath(['headers', 'X-Auth-Token'], getAuthToken(), config),
  )
}

export function putRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  return instance.put<T>(
    url,
    data,
    R.assocPath(['headers', 'X-Auth-Token'], getAuthToken(), config),
  )
}

export function deleteRequest<T>(
  url: string,
  data: any,
  config?: AxiosRequestConfig,
) {
  return instance.delete<T>(url, {
    data,
    ...R.assocPath(['headers', 'X-Auth-Token'], getAuthToken(), config),
  })
}
